import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';

const withScrollToError = (WrappedComponent) => {
  class ErrorScroll extends Component {
    componentDidUpdate(prevProps) {
      const { isSubmitting, isValidating, errors } = prevProps.formik;
      const errorFields = Object.keys(errors);

      if (errorFields.length > 0 && isSubmitting && !isValidating) {
        const selector = `[name="${errorFields[0]}"]`;
        const errorElement = document.querySelector(selector);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  ErrorScroll.propTypes = {
    formik: PropTypes.shape({
      isSubmitting: PropTypes.bool,
      isValidating: PropTypes.bool,
      errors: PropTypes.objectOf(PropTypes.string),
    }),
  };

  ErrorScroll.defaultProps = {
    formik: {
      isSubmitting: false,
      isValidating: false,
      errors: {},
    },
  };

  return connect(ErrorScroll);
};

export { withScrollToError };
